import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import {
  useInitData,
  useIsUserProfileNGAvailable,
  useUserData,
} from '../../../hooks'
import { ListItem } from '../../ListItem'
import { getUserLinkProps } from '../User.utils'

import {
  QA_NAME_USER_PROFILE_LINK,
  QA_NAME_USER_SETTINGS_LINK,
} from './UserMenuNameNav.constants'
import { getUserMenuPersonalSettingsLinkProps } from './UserMenuNameNav.utils'

import * as styles from './UserMenuNameNav.module.css'

function UserMenuNameNav({ owner }) {
  const { t } = useTranslation()

  const { availableSections } = useInitData()
  const isUserProfileNGAvailable = useIsUserProfileNGAvailable()
  const { role } = useUserData()

  const { LinkComponent, userLink } = getUserLinkProps({
    idKey: 'id',
    isUserProfileNGAvailable,
    user: { id: owner, role },
  })

  return (
    <>
      <LinkComponent {...userLink} className={styles.link}>
        <ListItem
          qaName={QA_NAME_USER_PROFILE_LINK}
          text={t('Header.CurrentProfileLinkKey')}
        />
      </LinkComponent>
      <Link
        {...getUserMenuPersonalSettingsLinkProps(availableSections)}
        className={styles.link}
      >
        <ListItem
          qaName={QA_NAME_USER_SETTINGS_LINK}
          text={t('Header.PersonalSettingsLinkKey')}
        />
      </Link>
    </>
  )
}

export default UserMenuNameNav
